import { toast as rht } from 'react-hot-toast';


const options = { 
    duration: 1500,
    position: "top-right" 
}

const success = (msg) => {
    return rht.success(msg, options)
}

const error = (msg) => {
    return rht.error(msg, options)
}

const warning = (msg) => {
    return rht.warning(msg, options)
}

const toast = {
    success,
    error,
    warning
}

export default toast